import { defineStore } from 'pinia'
import api from '@/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    expiresAt: localStorage.getItem('expiresAt') || null,
  }),

  getters: {
    isLoggedIn: (state) => {
      if (!state.token || !state.expiresAt) return false
      return new Date(state.expiresAt) > new Date()
    },
  },

  actions: {
    async login(username, password) {
      const { data } = await api.post('/auth/login', { username, password })
      this.token = data.token
      this.user = data.user
      this.expiresAt = data.expiresAt
      localStorage.setItem('token', data.token)
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('expiresAt', data.expiresAt)
    },

    logout() {
      const token = this.token
      this.token = null
      this.user = null
      this.expiresAt = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('expiresAt')
      if (token) {
        api.post('/auth/logout').catch(() => {})
      }
    },
  },
})
